// ----------------------------------------------------------------------

function path(root, sublink) {
  return `${root}${sublink}`;
}

export const ROOTS_AUTH = '';
export const ROOTS_DASHBOARD = '/dashboard';
export const ROOTS_PRIVATE = '/directAccess';

// ----------------------------------------------------------------------

export const PATH_AUTH = {
  root: ROOTS_AUTH,
  login: path(ROOTS_AUTH, ''),
  register: path(ROOTS_AUTH, '/register'),
  resetPassword: path(ROOTS_AUTH, '/reset-password'),
};


export const PATH_DASHBOARD = {
  root: ROOTS_DASHBOARD,
  general: {
    app: path(ROOTS_DASHBOARD, '/activity/demandes'),
    activity: path(ROOTS_DASHBOARD, '/activity'),
    administration: path(ROOTS_DASHBOARD, '/administration')
  },
  message: {
    root: path(ROOTS_DASHBOARD, '/activity'),
    list: path(ROOTS_DASHBOARD, '/activity/messages')
  },
  patient: {
    root: path(ROOTS_DASHBOARD, '/activity'),
    list: path(ROOTS_DASHBOARD, '/activity/patients'),
  },
  demandes: {
    root: path(ROOTS_DASHBOARD, '/activity'),
    list: path(ROOTS_DASHBOARD, '/activity/demandes'),
  },

  consultation: {
    root: path(ROOTS_DASHBOARD, '/access'),
    list: path(ROOTS_DASHBOARD, '/access/consultations'),
  },
  account: {
    root: path(ROOTS_DASHBOARD, '/access'),
    edit: path(ROOTS_DASHBOARD, '/access/account'),
  },
    preferences: {
    root: path(ROOTS_DASHBOARD, '/access'),
    edit: path(ROOTS_DASHBOARD, '/access/preferences'),
  },
  delegation: {
    root: path(ROOTS_DASHBOARD, '/access'),
    list: path(ROOTS_DASHBOARD, '/access/delegations'),
    add: path(ROOTS_DASHBOARD, '/access/delegation'),
    edit: path(ROOTS_DASHBOARD, '/access/delegation/edit')
  },
  association: {
    root: path(ROOTS_DASHBOARD, '/tools'),
    list: path(ROOTS_DASHBOARD, '/tools/associations'),
    add: path(ROOTS_DASHBOARD, '/tools/association'),
  },
  fusion: {
    root: path(ROOTS_DASHBOARD, '/tools'),
    list: path(ROOTS_DASHBOARD, '/tools/fusions'),
  },
  download: {
    root: path(ROOTS_DASHBOARD, '/tools'),
    list: path(ROOTS_DASHBOARD, '/tools/download'),
  },
  setting: {
    root: path(ROOTS_DASHBOARD, '/administration'),
    edit: path(ROOTS_DASHBOARD, '/administration/setting'),
  },
  profile: {
    root: path(ROOTS_DASHBOARD, '/administration'),
    list: path(ROOTS_DASHBOARD, '/administration/profiles'),
    add: path(ROOTS_DASHBOARD, '/administration/profile'),
  },
  user: {
    root: path(ROOTS_DASHBOARD, '/administration'),
    list: path(ROOTS_DASHBOARD, '/administration/users'),
    add: path(ROOTS_DASHBOARD, '/administration/user'),
  },
  actor: {
    root: path(ROOTS_DASHBOARD, '/administration'),
    list: path(ROOTS_DASHBOARD, '/administration/actors'),
    add: path(ROOTS_DASHBOARD, '/administration/actor'),
  },
  groups: {
    root: path(ROOTS_DASHBOARD, '/administration'),
    list: path(ROOTS_DASHBOARD, '/administration/groups'),
    add: path(ROOTS_DASHBOARD, '/administration/group'),
  },
  dictionary: {
    root: path(ROOTS_DASHBOARD, '/administration'),
    list: path(ROOTS_DASHBOARD, '/administration/dictionaries'),
    add: path(ROOTS_DASHBOARD, '/administration/dictionary'),
  },
  home: {
    root: path(ROOTS_DASHBOARD, '/administration'),
    app: path(ROOTS_DASHBOARD, '/home')
  },
};

export const PATH_PRIVATE = {
  root: ROOTS_PRIVATE,
  demandes: {
    list: path(ROOTS_PRIVATE, '/activity/demandes'),
  },
};